<div class="task {{taskExecution.relevance}}" matRipple
  (click)="taskExecution.task.type === TaskType.PICTURE ? pictureButton.click() : onClick() ">
  <sc-padding>
    <sc-flex>
      <sc-icon [iconClass]="iconClass"></sc-icon>
      <sc-content-spacer></sc-content-spacer>
      <sc-dictionary-label dictionaryKey="dd.TASK.{{taskExecution.task?.id}}.name"></sc-dictionary-label>
      <div>
        {{taskExecution?.task.name.dictionaryKey}}
      </div>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-icon iconClass="fa-triangle-exclamation"></sc-icon>
      <input #pictureButton name="pictureButton" type="file" accept="image/*" (change)="handleFileEvent($event)"
        style="display: none;" />
    </sc-flex>
  </sc-padding>
</div>
